import { useIsFetching } from "@tanstack/react-query";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router";

/** Na het laatste antwoord nog even laten opbouwen (grafieken, tabellen). */
const SETTLE_MS = 150;

/**
 * Scrolt naar de sectie uit de hash (`/portefeuille#deelportefeuilles`).
 *
 * De browser doet dat alleen bij het laden van de pagina, en react-router doet
 * het niet: een menu-item dat naar een sectie wijst landt anders bovenaan. Er
 * wordt gewacht tot alle vragen aan de API binnen zijn, want de blokken boven
 * de sectie groeien pas als hun data er is; eerder scrollen landt halverwege.
 * Eén keer per adres, zodat een latere verversing de lezer niet terugtrekt.
 */
export function useScrollToHash() {
  const { pathname, hash, key } = useLocation();
  const fetching = useIsFetching();
  const done = useRef<string | null>(null);

  useEffect(() => {
    if (!hash || fetching > 0 || done.current === key) return;
    const timer = window.setTimeout(() => {
      const target = document.getElementById(decodeURIComponent(hash.slice(1)));
      if (!target) return;
      done.current = key;
      // Direct, niet vloeiend: een vloeiende scroll loopt op animatieframes en
      // blijft in een achtergrondtabblad of de testbrowser op nul staan.
      target.scrollIntoView({ block: "start" });
    }, SETTLE_MS);
    return () => window.clearTimeout(timer);
  }, [pathname, hash, key, fetching]);
}
